<svelte:options accessors/>
<script>
    import NauiExplorer from "../../naui/pages/NauiExplorer.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";

    export let createUrl;
    export let filterUrl = '';

    export let data;
    export let columns;
    export let pages;
    export let filters;
    export let count;

    let filterData = {};

    function filter(ev) {
        filterData = Object.assign({}, ev.detail.filters);

        filterData.page = 1;
        if (ev.detail.term) {
            filterData.search = ev.detail.term;
        }
        if (ev.detail.ordering) {
            filterData.order_by = ev.detail.ordering.by;
            filterData.order_dir = ev.detail.ordering.dir;
        }
        console.log(filterData);
        update();
    }

    function next(ev) {
        filterData.page = ev.detail;
        update();
    }

    function update() {
        submitData(filterData, 'get', filterUrl)
            .then(res => {
                data = res.data;
                count = res.count;
                pages = res.pages;
            });
    }
</script>

<div class="py-15">
    <NauiExplorer {data} {pages} {count} {columns} {filters}
                  searchLabel="Buscar por número de servicio o nombre de cliente"
                  paginate={true} on:filter={filter} on:next={next}>
        <div slot="actions">
            <div class="flex">
                <NauiButton href={createUrl} caption="CREAR SOLICITUD" mode="stroked"/>
            </div>
        </div>
    </NauiExplorer>
</div>